/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Status_DeliveredInputs */

const cs_chat_status_delivered = /** @type {(inputs: Chat_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doručeno`)
};

const en_chat_status_delivered = /** @type {(inputs: Chat_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered`)
};

/**
* | output |
* | --- |
* | "Delivered" |
*
* @param {Chat_Status_DeliveredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_status_delivered = /** @type {((inputs?: Chat_Status_DeliveredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Status_DeliveredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_status_delivered(inputs)
	return cs_chat_status_delivered(inputs)
});